/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ vehicleRef: NonNullable<unknown> }} Vehicle_Action_Edit_TitleInputs */

const fr_vehicle_action_edit_title = /** @type {(inputs: Vehicle_Action_Edit_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Édition du véhicule ${i?.vehicleRef}`)
};

const en_vehicle_action_edit_title = /** @type {(inputs: Vehicle_Action_Edit_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Editing vehicle ${i?.vehicleRef}`)
};

/**
* | output |
* | --- |
* | "Editing vehicle {vehicleRef}" |
*
* @param {Vehicle_Action_Edit_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_edit_title = /** @type {((inputs: Vehicle_Action_Edit_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Edit_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_edit_title(inputs)
	return en_vehicle_action_edit_title(inputs)
});